import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import Spec, { QuerySpec } from "csi/core/Spec";
import StringRen from "csi/heading/String";
import declare from "dojo/_base/declare";
import locale from "csi/locale";

const KeycloakSecretRenderer = declare(StringRen, {

	/**
	 * @override
	 * Disable filtering
	 */
	getQuerySpec(ctx: Context, h: Heading, spec: Spec): QuerySpec {
		const qs = this.inherited<QuerySpec>(arguments);
		qs.notFilterable = true;
		qs.notSortable = true;
		return qs;
	},

	/**
	 * @override
	 * Disable comments
	 */
	canComment: function (ctx: Context, h: Heading) {
		return false;
	},

	/**
	 * @override
	 * Return KeycloakSecret if OAuth2Service type otherwise return empty string.
	 */
	_getValue(ctx: Context, h: Heading) {
		const node = ctx.getNode();
		return (node && node.AuthType == "centric://REFLECTION/INSTANCE/AuthenticationType/OAuth2Service") ? node.KeycloakSecret : "";
	},

	/**
	 * @override
	 * Return asterisk if KeycloakSecret has non empty value.
	 */
	formatValue: function (value: any, fmt: string) {
		return (value != null) ? this.inherited(arguments) : locale.resource("ASTERISK");
	},
});

export = KeycloakSecretRenderer;